export default __webpack_public_path__ + "static/top-d5b37fdcfc13ca6b9c9a1a7175c8d203.png";